import { TextInput } from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const companyFilterList = [
  // <TextInput
  //   source="all"
  //   label="mine.filter.search_all"
  //   alwaysOn
  //   resettable
  //   variant="outlined"
  //   InputProps={{
  //     endAdornment: (
  //       <InputAdornment position="end">
  //         <SearchIcon />
  //       </InputAdornment>
  //     ),
  //   }}
  // />,
  <TextInput
    alwaysOn
    resettable
    source="alias"
    label="mine.label.name"
    variant="outlined"
  />,
  <TextInput
    alwaysOn
    resettable
    source="address"
    label="mine.label.address"
    variant="outlined"
  />,
  <TextInput
    alwaysOn
    resettable
    source="phone"
    variant="outlined"
  />,
  <TextInput alwaysOn resettable source="fax" variant="outlined" />,
  <TextInput alwaysOn resettable source="bank" variant="outlined" />,
];

export default companyFilterList;
